function StatusPill({ children }) {
  return (
    <span className="inline-flex rounded-full bg-cyan-300/10 px-2.5 py-1 text-xs font-semibold text-cyan-200">
      {children}
    </span>
  );
}

export default StatusPill;
